import { render } from "./payslip-index.vue?vue&type=template&id=2cf908c7"
import script from "./payslip-index.vue?vue&type=script&lang=js"
export * from "./payslip-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__